import {ajaxAxiosPost, ajaxAxiosPostP} from '../libs/ajax'
import {getCurrentMHost, getCurrentSvcMHost, getCurrentApiHost, getCurrentSvcApiHost, isDeviceInApp} from '../libs/utils'
import letsgoApi from '../libs/jsapi'
console.log('before letsgo')
console.log('after letsgo')

export function getDataProxy (params, cb, errCb) {
  if (isDeviceInApp()) {
    console.log('in app')
    letsgoApi.getDataProxy(params, (result) => {
      cb && cb(result)
    }, errCb)
  } else {
    // console.log('not in app')
    ajaxAxiosPost(getCurrentMHost() + '/v1/data_proxy', params, cb, errCb)
  }
}

export function getDataProxyAsync (params) {
  if (isDeviceInApp()) {
    console.log('in app')
    return new Promise((resolve, reject) => {
      letsgoApi.getDataProxy(params, result => {
        if (result['code'] === 400) {
          reject(result)
        } else {
          resolve(result)
        }
      })
    })
  } else {
    // console.log('not in app')
    return ajaxAxiosPostP(getCurrentApiHost() + '/v1/data_proxy', params)
  }
}

export function getNoAuthDataProxy (params) {
  return ajaxAxiosPostP(getCurrentMHost() + '/v1/n_data_proxy', params)
}

export function getSvcNoAuthDataProxy (params) {
  return ajaxAxiosPostP(getCurrentSvcMHost() + '/v1/n_data_proxy', params)
}

export function getNoAuthDataProxyAsync (params) {
  return ajaxAxiosPostP(getCurrentMHost() + '/v1/n_data_proxy', params)
}

export function getOptionalDataProxyAsync (params) {
  if (isDeviceInApp()) {
    console.log('in app')
    return new Promise((resolve, reject) => {
      letsgoApi.getDataProxy(params, resolve, reject)
    })
  } else {
    // console.log('not in app')
    return ajaxAxiosPostP(getCurrentApiHost() + '/v1/optional_data_proxy', params)
  }
}

const COMMAND_PROXY_RPC_GET = 'proxy_rpc_get'
const COMMAND_PROXY_RPC_POST = 'proxy_rpc_post'
const COMMAND_PROXY_RPC_GET_M = 'proxy_rpc_get_m'
const COMMAND_PROXY_RPC_POST_M = 'proxy_rpc_post_m'

export function postRequest (url, params) {
  if (!params) {
    params = {}
  }
  params['_command'] = url
  if (isDeviceInApp()) {
    console.log('in app')
    return new Promise((resolve) => {
      letsgoApi.getDataProxy({
        type: COMMAND_PROXY_RPC_POST,
        request_data: params
      }, resolve)
    })
  } else {
    return ajaxAxiosPostP(getCurrentApiHost() + '/v1/data_proxy', {
      type: COMMAND_PROXY_RPC_POST_M,
      request_data: params
    })
  }
}

export function getRequest (url, params) {
  if (!params) {
    params = {}
  }
  params['_command'] = url
  if (isDeviceInApp()) {
    console.log('in app')
    return new Promise((resolve) => {
      letsgoApi.getDataProxy({
        type: COMMAND_PROXY_RPC_GET,
        request_data: params
      }, resolve)
    })
  } else {
    return ajaxAxiosPostP(getCurrentApiHost() + '/v1/data_proxy', {
      type: COMMAND_PROXY_RPC_GET_M,
      request_data: params
    })
  }
}

export function getSvcRequest (url, params) {
  if (!params) {
    params = {}
  }
  params['_command'] = url
  if (isDeviceInApp()) {
    console.log('in app')
    return new Promise((resolve) => {
      letsgoApi.getDataProxy({
        type: COMMAND_PROXY_RPC_GET,
        request_data: params
      }, resolve)
    })
  } else {
    return ajaxAxiosPostP(getCurrentSvcApiHost() + '/v1/data_proxy', {
      type: COMMAND_PROXY_RPC_GET_M,
      request_data: params
    })
  }
}

export function getPlaceOrderHost () {
  if (isDeviceInApp()) {
    return getCurrentApiHost()
  } else {
    return getCurrentMHost()
  }
}

export function placeOrder (params, cb, finalCb) {
  console.log('place order')
  if (isDeviceInApp()) {
    letsgoApi.placeOrder(params, cb)
  } else {
    console.log('place order not in device')
    let orderUrl = params['place_order_url']
    ajaxAxiosPost(orderUrl, params, (result) => {
      finalCb && finalCb()
      cb && cb(result)
    }, (err) => {
      finalCb && finalCb()
      letsgoApi.toast(err.message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/hybrid_api.js